module.exports = __webpack_public_path__ + "img/funDeatilNewData.07c91d54.png";